import { rem } from "@mantine/core";
import { closeModal, openContextModal } from "@mantine/modals";
import type { WhiteboardDocumentId } from "../collaboration/document-id";
import { ShareWhiteboardPanelModal } from "./share-whiteboard-panel-modal";

let modalId: string | null = null;

export const openSharingModal = (whiteboardId: WhiteboardDocumentId) => {
	modalId = openContextModal({
		modal: "buttonsModal",
		radius: "md",
		padding: rem(24),
		centered: true,
		withCloseButton: false,
		zIndex: 2000,
		innerProps: {
			children: <ShareWhiteboardPanelModal whiteboardId={whiteboardId} />,
		},
	});
};

export const closeSharingModal = () => {
	if (modalId) {
		closeModal(modalId);
		modalId = null;
	}
};
